import { Option, OptionDuplicateInput } from '../../lib/types/models/options/option'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function duplicateOption(data: IdInput<OptionDuplicateInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.options.duplicate.url, { id }))
    .post<Option, OptionDuplicateInput>(rest)
}
